import { IMedia } from "@types";
import { BaseAPI } from "@utils";

class MediaApi extends BaseAPI<IMedia> {}

export const mediaApi = new MediaApi("/api/v1/media");
